import { Breadcrumbs, Layout } from '@components/common'
import commerce from '@lib/api/commerce'
import getGlobalStaticProps from '@lib/get-global-static-props'
import { createClient, getDocByUid } from '@lib/prismicio'
import { SliceZone } from '@prismicio/react'
import { PrismicDocument } from '@prismicio/types'
import { AnalyticsPageType } from '@shopify/hydrogen-react'
import type { GetStaticPropsContext } from 'next'
import { components } from 'slices'

export async function getStaticProps({
  preview,
  previewData,
  locale,
  locales,
}: GetStaticPropsContext) {
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)

  const config = { locale, locales }

  const shopifyPagePromise = commerce.getPageByHandle({
    variables: { handle: 'index' },
    config,
    preview,
  })

  const prismicDocPromise = await getDocByUid(
    'brands-page',
    'brands-page',
    client,
    locale
  )

  const { page: shopifyPage } = await shopifyPagePromise
  const prismicDoc: PrismicDocument | null = await prismicDocPromise

  if (!shopifyPage || !prismicDoc) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      ...globalProps,
      prismicDoc,
      analyticsPayload: {
        pageType: AnalyticsPageType.page,
      },
    },
    revalidate: 600,
  }
}

type PageProps = {
  prismicDoc: PrismicDocument | null
}

export default function Brands({ prismicDoc }: PageProps) {
  return (
    <>
      <div className="wrapper">
        <Breadcrumbs current="Brands" />
      </div>
      <SliceZone slices={prismicDoc?.data.slices} components={components} />
    </>
  )
}

Brands.Layout = Layout
